// @ts-nocheck
import { useMutation, useQuery } from '@tanstack/react-query';
import { EMPTY_OBJECT } from '../const/CommonConst';

const useQueryEngine = (queryKey, queryFn, options = EMPTY_OBJECT) => {
  // Default options that align with project standards
  const defaultOptions = {
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff: 1s, 2s, 4s... capped at 30s
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...options,
  };
  // useQuery expects an object with queryKey and queryFn, plus any additional options
  const query = useQuery({
    queryKey,
    queryFn,
    ...defaultOptions,
  });

  return query;
};

const useMutationEngine = (mutationFn, options = EMPTY_OBJECT) => {
  const defaultOptions = {
    retry: 2, // Retry twice on failure
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff delay with 30s maximum
    ...options,
  };

  return useMutation({
    mutationFn,
    ...defaultOptions,
  });
};
export { useQueryEngine, useMutationEngine };
